import { pluralize, lowercase } from '~/utils/string_utils';

export default {
  capitalize: function (value) {
    if (!value) {
      return '';
    }
    value = value.toString();

    return value.charAt(0).toUpperCase() + value.slice(1);
  },
  // the pluralWord is optional
  // e.g: pluralize(2, 'filter') => 'filters'
  //      pluralize(1, 'filter') => 'filter'
  //      pluralize(2, 'index', 'indexes') => 'indexes'
  //      pluralize(1, 'index', 'indexes') => 'index'
  pluralize,
  lowercase,
};
